// Wait for the document to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  
  // Select all links that start with '#' and aren't just '#'
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
    
    // Add a click listener to each selected link
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // Stop the instant jump default behavior
      
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        // Use the native scrollIntoView method with 'smooth' behavior
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // Aligns the top of the element with the top of the viewport
        });
      }
    });
  });
});